module.exports = __webpack_public_path__ + "static/media/error_400_mobile.6ee76a5d.svg";